export const ADD_CANVAS = 'ADD_CANVAS' as 'ADD_CANVAS';
export const DELETE_CANVAS = 'DELETE_CANVAS' as 'DELETE_CANVAS';
export const CLEAR_CANVAS = 'CLEAR_CANVAS' as 'CLEAR_CANVAS';
export const ADD_RESOURCE_TO_CANVAS = 'ADD_RESOURCE_TO_CANVAS' as 'ADD_RESOURCE_TO_CANVAS';
export const DELETE_RESOURCE_FROM_CANVAS = 'DELETE_RESOURCE_FROM_CANVAS' as 'DELETE_RESOURCE_FROM_CANVAS';
export const DELETE_RESOURCE_FROM_ALL_CANVASES = 'DELETE_RESOURCE_FROM_ALL_CANVASES' as 'DELETE_RESOURCE_FROM_ALL_CANVASES';
export const UPDATE_RESOURCES_OF_CANVAS = 'UPDATE_RESOURCES_OF_CANVAS' as 'UPDATE_RESOURCES_OF_CANVAS';
export const ADD_CONNECTION_TO_CANVAS = 'ADD_CONNECTION_TO_CANVAS' as 'ADD_CONNECTION_TO_CANVAS';
export const DELETE_ALL_CONNECTIONS_FROM_CANVAS = 'DELETE_ALL_CONNECTIONS_FROM_CANVAS' as 'DELETE_ALL_CONNECTIONS_FROM_CANVAS';
